export interface IFacility {
  id: string;
  name?: string;
  field?: string;
  code: string,
}

export interface IGetFacilitiesResponse extends IFacility {
  code: string;
  name: string;
  filter: null | unknown;
  sort: null | unknown;
  limit: number;
  skip: number;
  count: number;
  fields: null | string[];
  headers: string[];
  columnStyles: null | unknown;
  records: [[number | string]]
}

export interface IGetZonesResponse {
  code: string;
  name: string;
  filter: null | unknown;
  sort: null | unknown;
  limit: number;
  skip: number;
  count: number;
  fields: null | string[];
  headers: string[];
  columnStyles: null | unknown;
  records: [[number|string]];
}

export interface IZone {
  group_id?:null | string;
  id?:string | number;
  name?:string;
  properties?:ICreateProperty[];
}

export interface IZones {
  data:IZone[];
  count:number;
  propertyNames: string[]
}

export interface IGetZone {
  name?:string,
  fields?: null | string[],
  headers?: string[],
  records?: [[number|string|Record<string, number|string>]]
}

export enum iconNames {
  icon1 = 'icon1',
  icon2 = 'icon2',
  icon3 = 'icon3',
  icon4 = 'icon4',
  icon5 = 'icon5',
}

export interface IGroupType {
  id: number,
  tenant: string,
  groupType_id: null | number,
  name: string
  icon: iconNames | null,
}
export type IGetGroupTypesResponse = IGroupType[];

export interface IGroup {
  id:number,
  groupType_id:number,
  group_id:number | null,
  groupType_name:string,
  groupType: IGroupType,
  name:string
  code:string,
  zones: IZones
}

export interface IFormattedGroup {
  [key:string]: IGroup
}

export type IGetGroupsResponse = IGroup[];

export type IChildren = {
  id:number,
  group_id:number | null,
  groupType_name: string,
  groupType_id?:number,
  groupType: IGroupType,
  name:string,
  code: string,
  children?:IChildren
}[];

export type IGroupsTree = {
  id:number,
  group_id:number | null,
  name:string,
  code: string,
  groupType_name: string,
  groupType: IGroupType,
  groupType_id?:number,
  children?:IChildren
};

export type IGroupsTreeResponse = IGroupsTree[];

export interface IGroupsByTypes {
  [key:string]: number[]
}

export interface ICreateGroup {
  groupType_id?:string,
  group_id:string | null,
  name:string,
  code: string
}

export interface IEditGroup {
  name:string,
  code: string,
  id:string | number,
}

export interface IEditMapOrigin {
  group_id?:string | null,
  name?:string,
  longitude?:number | string,
  latitude?:number | string,
  elevation?:number | string
  azimuth?:number | string,
  units?:string
}

export interface IEditImage {
  mapImageId?:number,
  mapOrigin_id?:number | string,
  xofffset?:number | string,
  yoffset?:number | string,
  theta?:number | string,
  pixelsPerLength?:number | string,
}

export interface ICreateZone {
  group_id?: string | null,
  name: string,
  properties?: ICreateProperty[],
  [key:string]:unknown
}

export interface ICreateProperty {
  name:string,
  zone_id?: string | number,
  value:string,
  id?: number,
  isEdited?:boolean,
  isStatic?:boolean
}

export interface IDeleteGroup {
  id:string|number,
}

export interface ICreateGroupType {
  groupType_id: number | null,
  name: string,
  icon: null | string,
  tenant:string
}

export interface IEditGroupType {
  name: string,
  icon: null | string,
  id: string,
}

export interface ILogicalReaders {
  [key:string]: ILogicalReader[]
}

export interface ILogicalReader {
  id: number,
  name: string,
  direction?: string | null,
  zone_id: number,
  order: number,
  isNew? : boolean;
}

export interface IPolygon {
  id?:number,
  zone_id?:number,
  points:string
}
export interface IGetMapOriginResponse {
  id?:number,
  group_id?:string | number | undefined,
  group_code?:string | undefined,
  name?:string,
  longitude?:number | string,
  latitude?:number | string,
  elevation?:number | string
  azimuth?:number | string,
  units?:string | string,
}
export interface IGetMapImageResponse {
  id?:number,
  mapOrigin_id?:number | string,
  name?:string | string,
  xofffset?:number | string,
  yoffset?:number | string,
  theta?:number | string,
  pixelsPerLength?:number | string,
}
export interface IGetMapImageImageResponse {
  data?: Blob,
}

export interface IGetMapReportDefinitionResponse {
  id: number,
  reportdef_id: number,
  name: string,
  config: IGetMapDefinitionConfig,
}

export interface IGetMapReportDefinitionDefaultResponse {
  reportdef_id: number,
  name: string,
  config: IGetMapDefinitionConfig,
}

export interface IMapViewState {
  pan: [number, number], // [lat, lng]
  zoom: number,
}

export interface IGetMapDefinitionConfig {
  orientation?: string,
  visibility?: IGetMapVisibility | undefined,
  transparency?: IGetMapTransparency,
  expertOptions?: IGetMapExpertOptions,
  pageSize?: number;
  drawerCollapsed?: boolean;
  popupFields?: string[];
  viewStates?: Record<string, IMapViewState>;
}

export interface IGetMapVisibility {
  image: boolean,
  points?: boolean,
  pointLabels?: boolean,
  zones?: boolean,
  zoneLabels?: boolean,
  xyAxes?: boolean,
  xyAxesLabels?: boolean,
  xyGrid?: boolean,
  llAxis?: boolean,
  llAxisLabels?: boolean,
  llGrid?: boolean,
  canvasCenter?: boolean,
  mapBoundingBox?: boolean,
  thetaDefinition?: boolean,
  pointCircles?: boolean,
  vectors?: boolean,
  vectors2?: boolean,
  zoom?: boolean,
  mapVisibilityControls?: boolean,
  clusteredPinsByZone?: boolean,
  clusteredPins?: boolean,
  readerips?: boolean,
  readerNames?: boolean,
  antennas?: boolean,
  antennaLabels?: boolean,
  connections?: boolean,
  llAxes?: boolean,
  llAxesLabels?: boolean,
  cor?: boolean,
}

export interface IGetMapTransparency {
  image?: number,
  xygrid?: number,
  xyaxis?: number,
  llgrid?: number,
  points?: number,
  zones?: number,
}

export interface IGetMapExpertOptions {
  points?: string,
}
